export const EXECUTIVES = [
  { username: "executive_tamanna", name: "Executive Tamanna" },
  { username: "premier_tamanna", name: "Premier Tamanna" },
  { username: "imperial_tamanna", name: "Imperial Tamanna" },
  { username: "bizz_tamanna", name: "Bizz Tamanna" },
  { username: "grand_tamanna", name: "Grand Tamanna" },
];

export const EXEC_MAP = EXECUTIVES.reduce((acc, e) => {
  acc[e.username] = e.name;
  return acc;
}, {});

export const SOURCES = [
  "Direct Walk-in",
  "Website Inquiry",
  "Corporate Reference",
  "Wedding Planner",
  "Social Media",
  "Repeat Client",
  "Cold Outreach",
  "Phone Call",
  "Justdial",
  "Wedding Wire",
  "Wedmegood",
  "Venuelook",
];

export const STATUS_META = {
  pending: {
    label: "Pending",
    badge: "bg-amber-50 text-amber-800 border-amber-200",
    dot: "bg-amber-500",
  },
  success: {
    label: "Success",
    badge: "bg-emerald-50 text-emerald-800 border-emerald-200",
    dot: "bg-emerald-500",
  },
  failed: {
    label: "Failed",
    badge: "bg-rose-50 text-rose-800 border-rose-200",
    dot: "bg-rose-500",
  },
};

export const DEMO_LOGINS = [
  { label: "Executive Tamanna", email: "executive@tamannahotels.com", role: "Executive view" },
  { label: "Sales Manager", email: "manager@tamannahotels.com", role: "Manager view" },
  { label: "Management Admin", email: "prathveesh.shetty@tamannahotels.com", role: "Delete rights" },
];
